module.exports = __webpack_public_path__ + "media/images/responsive/page_common/banner/banner_dress_collection-d605e88e82c8c841113e2abac52704ab.jpg";